import { isEmpty, isNil } from 'lodash';

// Dead simple until we need it do be complex. Make a singular string plural by
// adding an "s".
export const plural = (str = ''): string => `${str}s`;

export const isNotNillOrEmpty = (value: unknown) =>
  !isNil(value) && !isEmpty(value);

export const snakeCaseString = (str: string | null | undefined) =>
  str?.replace(/\s/g, '_');

export const highlightSubstring = (str: string, substring: string) => {
  if (!substring) {
    return str;
  }
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions#escaping
  const escapedSubstring = substring.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return str.replaceAll(
    new RegExp(escapedSubstring, 'ig'),
    (match) => `<strong>${match}</strong>`,
  );
};

// Matches emoji for stripping. The single-code-point properties miss
// multi-code-point sequences, so the leading alternatives cover keycaps
// (digit + optional VS16 + enclosing keycap, e.g. 1️⃣) and flags (regional
// indicator pairs) explicitly, while the trailing class removes leftover
// joiners, variation selectors, and skin-tone modifiers from ZWJ/modifier
// sequences. \p{Extended_Pictographic} also catches bare symbols (®, ©, ™).
export const EMOJI_REGEX =
  /[#*0-9]\u{FE0F}?\u{20E3}|[\u{1F1E6}-\u{1F1FF}]{2}|[\p{Emoji_Presentation}\p{Extended_Pictographic}]|[\u{200D}\u{FE0F}\u{FE0E}\u{20E3}\u{1F3FB}-\u{1F3FF}]/gu;

export const stripEmoji = (str: string) => str.replace(EMOJI_REGEX, '');

// Normalizes an address string for plain equality comparison: lowercased,
// punctuation stripped, internal whitespace collapsed to single spaces, and
// trimmed.
export const normalizeAddressForMatch = (
  str: string | null | undefined,
): string =>
  (str ?? '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]/gu, '') // drop punctuation/symbols
    .replace(/\s+/g, ' ')
    .trim();
